/**
 * content-active.js
 */

import React from 'react';
import {
  Box,
  Grid,
} from '@mui/material';
import { format } from 'date-fns';
import { getTrackDistanceM } from 'utils/distance';
import { LiveTrackingContext } from '../live-tracking/live-tracking-context';
import { 
  GridCell, 
  LocationAccuracyChip, 
  DurationGridCell, 
  DistanceGridCell 
} from './control-common';


export default function ContentActive(props) {
  const { currentLocation, activeTrack } = React.useContext(LiveTrackingContext);
  const [elapsedTime, setElapsedTime] = React.useState(0);
  
  let startTime = '';
  let distance = 0;
  let persistedPoints = '';

  if (activeTrack) {
    // start time
    const startDateTime = activeTrack.dateTimeCreated;
    startTime = format(startDateTime, 'HH:mm:ss');

    // distance
    distance = Math.round(getTrackDistanceM(activeTrack.points));

    // point count
    persistedPoints = `${activeTrack.persistedPointCount} / ${activeTrack.collectedPointCount}`;
  }


  // elapsed time uses a timeout/rerender cycle to keep updated
  React.useEffect(() => {
    if (activeTrack?.dateTimeCreated) {
      setTimeout(() => {
        const elap = (new Date().getTime() - new Date(activeTrack.dateTimeCreated).getTime()) / 1000;
        setElapsedTime(elap);
      }, 1000);
    }
  }, [activeTrack?.dateTimeCreated, elapsedTime]);


  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={6}><GridCell iconId='clock' content={`${startTime} start`} /></Grid>
        <Grid item xs={6}><DurationGridCell seconds={elapsedTime} /></Grid>
        <Grid item xs={6}><DistanceGridCell distance={distance} /></Grid>
        <Grid item xs={6}><GridCell iconId='upload' content={`${persistedPoints} pts uploaded`} /></Grid>
        <Grid item xs={6}><GridCell iconId='location-accuracy' content={<>
          <Box display='inline' sx={{ mr: 1 }}>GPS: </Box><LocationAccuracyChip accuracy={currentLocation?.accuracy} />
        </>} /></Grid>
      </Grid>
    </>
  );
}